{
  "passes": [
    {
      "id": "network-performance",
      "name": "Network Performance",
      "description": "Detect slow requests, large payloads, and waterfall issues",
      "tasks": [
        {
          "scriptGuidance": "polish/network-performance/script.ts",
          "readsRecordingEvents": true
        }
      ]
    },
    {
      "id": "react-rendering",
      "name": "React Rendering",
      "description": "Detect React errors, error-boundary crashes, remount thrash, render loops, and rendering performance problems",
      "tasks": [
        {
          "scriptGuidance": "polish/react-rendering/script.ts"
        }
      ]
    },
    {
      "id": "layout-shift",
      "name": "Layout Shift",
      "description": "Identify elements that shift unexpectedly during load",
      "tasks": [
        {
          "scriptGuidance": "polish/layout-shift/script.ts"
        }
      ]
    },
    {
      "id": "accessibility",
      "name": "Accessibility",
      "description": "Check for WCAG violations, including text color contrast",
      "tasks": [
        {
          "scriptGuidance": "polish/accessibility/script.ts"
        },
        {
          "scriptGuidance": "polish/accessibility/contrast-script.ts",
          "readsRecordingEvents": true,
          "signals": ["low-contrast-text", "invisible-text"],
          "files": ["low-contrast-text"]
        }
      ]
    },
    {
      "id": "glitches",
      "name": "Glitches",
      "description": "Spot visual glitches, flickers, and rendering artifacts",
      "tasks": [
        {
          "scriptGuidance": "polish/glitches/script.ts",
          "readsRecordingEvents": true
        }
      ]
    },
    {
      "id": "user-experience",
      "name": "User Experience",
      "description": "Analyze interactions for usability improvements and intuitive design",
      "tasks": [
        {
          "scriptGuidance": "polish/user-experience/script.ts",
          "readsRecordingEvents": true
        }
      ]
    },
    {
      "id": "seo",
      "name": "SEO",
      "description": "Check how search engines discover, index, and present the app's pages: titles, descriptions, canonicals, robots directives, crawlable navigation, and metadata duplicated across pages",
      "tasks": [
        {
          "scriptGuidance": "polish/seo/script.ts"
        }
      ]
    },
    {
      "id": "ui-details",
      "name": "UI Details",
      "description": "Examine recordings for UI features that need detailed testing like rich text editors, drag-and-drop, search, and date pickers",
      "tasks": [
        {
          "scriptGuidance": "polish/ui-details/script.ts"
        }
      ]
    },
    {
      "id": "security",
      "name": "Security",
      "description": "Find client-side security defects in the recording, and \u2014 when the project has verified site ownership \u2014 probe the live target for access-control, authorization, and injection flaws",
      "defaultEnabled": false,
      "tasks": [
        {
          "scriptGuidance": "polish/security/script-review.ts"
        },
        {
          "scriptGuidance": "polish/security/script-probe.ts"
        }
      ]
    }
  ]
}
